import { Component, OnInit } from '@angular/core';
import { NavigationDataKey } from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';

@Component({
	selector: 'communication-template-example-component',
	templateUrl: 'communication-template-example.component.html',
	styleUrls: ['./communication-template-example.component.scss'],
})
export class CommunicationTemplateExampleComponent implements OnInit {
	public html: string;

	constructor(private readonly navigationService: NavigationService) {}

	public ngOnInit(): void {
		this.html = this.navigationService.getNavigationData(NavigationDataKey.html);
	}
}
